import { render, staticRenderFns } from "./consultListJg.vue?vue&type=template&id=a2413ca4&scoped=true"
import script from "./consultListJg.vue?vue&type=script&lang=js"
export * from "./consultListJg.vue?vue&type=script&lang=js"
import style0 from "./consultListJg.vue?vue&type=style&index=0&id=a2413ca4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2413ca4",
  null
  
)

export default component.exports